import { useEffect, useRef } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import styles from "./Slider.module.css";

export default function Slider({ images }) {
  const slideRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowRight") {
        slideRef.current.goNext();
      } else if (event.key === "ArrowLeft") {
        slideRef.current.goBack();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className={styles.container}>
      <Slide ref={slideRef} autoplay={false} easing="ease">
        {images.map((slide, index) => (
          <div className={styles.slide} key={index}>
            <img src={slide} alt={`Slide ${index}`} className={styles.image} />
          </div>
        ))}
      </Slide>
    </div>
  );
}
